import styled from '@emotion/styled';

export const LoadingContainer = styled('main')(({ theme }) => ({
  minHeight: '100dvh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.colors.background.canvas,
}));
